import {Component, OnInit, TemplateRef} from '@angular/core';
import {TypeDocument, type_client} from "../../../../model/db";
import {ActivatedRoute} from "@angular/router";
import {AuthServiceService} from "../../../../service/auth-service.service";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../service/helper.service";
import {valuesys} from "../../../../../../options";
import Swal from 'sweetalert2' ;
import {Translatable} from "../../../../../Translatable";
import {DataTablesResponse} from "../../../../model/DataTablesResponse";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {environment} from "../../../../../../environments/environment";
import * as $ from "jquery";

@Component({
  selector: 'app-type-document',
  templateUrl: './type-document.component.html',
  styleUrls: ['./type-document.component.css']
})
export class TypeDocumentComponent extends Translatable implements OnInit {

  title:string ;
  dtOptions: DataTables.Settings = {};

  titleModal:string ;
  //titleProfilage:string=this.__('profil.profils') ;
  isAdd : boolean = true ;
  isValid : boolean = false ;
  modalRef: BsModalRef;
  listeDocs: any[] = [];
  typeDocument: TypeDocument = new TypeDocument();
  typeDoc: TypeDocument;


  public type_clients:type_client [] = [];

  public type_client:type_client  = new type_client();
  type_client_error: type_client;
  constructor(private activatedRoute: ActivatedRoute,
              private auth : AuthServiceService,
              private http: HttpClient,
              private toastr: ToastrService,
              private helper: HelperService,
              private modalService: BsModalService,
              private ngxService: NgxUiLoaderService
  ) {
    super();
  }
  async ngOnInit() {

    // const listeTypedocFrais = this.http.get(environment.type_doc_frais,valuesys.httpAuthOptions()).toPromise();
    // console.log(listeTypedocFrais,"frais doc")

    this.auth.initAutority("TCL");

    this.isAdd = true ;
    this.isValid = false ;
    this.title = this.__("lebel_users");
    this.initDatatable()
    //console.log(" liste des droits "+this.listeModules);


  }

  initDatatable(){
    this.dtOptions = this.helper.dataTableOption();
    this.dtOptions.columns = [
      {data:"code"},
      //{data:"state"}
    ]  ;
    this.dtOptions.ajax = (dataTablesParameters: any, callback) => {
      this.http
          .get<DataTablesResponse>(
              environment.type_doc_frais +"?"+  $.param(dataTablesParameters), valuesys.httpAuthOptionsProcess()
          ).subscribe(resp => {
            this.listeDocs = resp.data;
            console.log(resp,"zzzz")
        // this.type_clients = resp.data;
        callback({
          recordsTotal: resp.recordsTotal,
          recordsFiltered: resp.recordsFiltered,
          data:[]
        });
      });
    }
  }

  async addTypeDocument(){
    console.log("xxxx: ",this.typeDocument)
    this.isValid = true ;
    if(this.isAdd ){
      console.log(this.type_client);
      let res =  await this.http.post<any>( environment.type_doc_frais,this.typeDocument,valuesys.httpAuthOptions()).toPromise();
      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;
        //this.rerender();
        this.listeDocs.push(res.data);
        this.close()
      }else if(res.code === 400){
        this.type_client_error = <type_client> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }else {

      console.log("FAL PROF",this.type_client);
      const docToUpdate = {
        code: this.typeDocument.code,
        description: this.typeDocument.description
      }
      let res =  await this.http.put<any>( environment.type_doc_frais +"/"+this.typeDocument.id,docToUpdate,valuesys.httpAuthOptions()).toPromise();

      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;

        this.close()
      }else if(res.code === 400){
        this.type_client_error = <type_client> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }
    this.isValid = false ;

  }
  async openModal(template: TemplateRef<any>,currentTypeDoc: any,btn:any) {
    console.log(currentTypeDoc,"type doc")
    btn.disabled= true
    this.type_client_error = new type_client();
    if(currentTypeDoc == null){
      this.isAdd = true ;
      this.titleModal = this.__('type_doc.text_type_doc_title') ;
    }else {
      this.isAdd = false ;
      this.titleModal = this.__('type_client.edit') ;
      let res = await this.http.get<any>(environment.type_doc_frais + '/' + currentTypeDoc.id,valuesys.httpAuthOptions()).toPromise();
      this.typeDocument = currentTypeDoc ;

    }
    btn.disabled= false

    this.modalRef = this.modalService.show(template,{ignoreBackdropClick:true});
  }
  close(){
    this.type_client_error = new type_client();
    this.type_client = new type_client();
    this.titleModal = "" ;
    this.modalRef.hide()
  }
  delete(typeDoc:TypeDocument,btn:any){
    btn.disabled= true
    Swal.fire({
      title: this.__('msg.confirm'),
      text: this.__('msg.warning_delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.__('msg.confirmed_delete'),
      cancelButtonText: this.__('msg.cancel_delete')
    }).then(async (result) => {
      if (result.value) {
        let sup = await this.http.delete<any>(environment.type_doc_frais+"/"+typeDoc.id,valuesys.httpAuthOptions()).toPromise();
        if(sup.code == 204){
          this.listeDocs= this.listeDocs.filter(function (item,index) {
            return item.id != typeDoc.id
          });
          btn.disabled= false
          Swal.fire(
              this.__('msg.deleted'),
              sup.msg,
              'success'
          )
        }else {
          btn.disabled= false
          this.toastr.error(sup.msg,this.__("msg.error"));
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
            this.__('msg.canceled'),
            this.__('msg.canceled_delete'),
            'error'
        )
        btn.disabled= false
      }
    })
  }


  async toggleState(type:type_client,state:number,btn:any){
    console.log(btn.hidden = true)
    $(btn).attr('disabled');
    btn.disabled = true;
    let toogle = await this.http.get<any>( environment.type_doc_frais+`/${type.id}/${state}/state`,valuesys.httpAuthOptions()).toPromise();
    if(toogle.code == 201){
      this.toastr.success(toogle.msg,this.__("msg.success"));
      type.state = toogle.data.state

    }else {
      this.toastr.error(toogle.msg,this.__("msg.error"));
    }
    btn.disabled = false;
  }


}

